import { motion } from "framer-motion";

export default function BenefitsSection() {
    const benefits = [
        {
            title: "FLOAT SWITCH MONITORING",
            description: "iFLO Pro provides the option to connect directly to your float switch, giving you peace of mind when you depend on digital alerts when the circuit is tripped.",
            image: "/kititems/hanger.png"
        },
        {
            title: "EXCLUSIVE FORMULA",
            description: "The Pro Formula is our strongest concentration possible which is 100% safe for your unit D.O.T. certified with (TDG) safety data.",
            image: "/kititems/formula.png"
        },
        {
            title: "ADMIN PANEL ACCESS",
            description: "The admin panel helps you to digitally service your customers from anywhere. Monitor all your devices from one place and know when and where service is needed.",
            image: "/Insurance/panel.png"
        }
    ];

    return (
        <section id="benefits" className="bg-white text-black py-16 px-6">
            <div className="max-w-7xl mx-auto">
                {/*<motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl font-bold mb-4">IFLO PRO BENEFITS</h2>
                    <h3 className="text-xl text-yellow-400">Groundbreaking & Innovative</h3>
                </motion.div>*/}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {benefits.map((benefit, index) => (
                        <motion.div
                            key={benefit.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.2 }}
                            className="bg-gray-100 border border-yellow-400 p-4 rounded-sm text-center flex flex-col h-full"
                        >
                            <div className="mb-6 h-96 flex items-center justify-center">
                                <img
                                    src={benefit.image}
                                    alt={benefit.title}
                                    className="max-h-full object-contain"
                                />
                            </div>
                            <div className="flex flex-col justify-center flex-grow">
                                <h4 className="text-2xl font-bold mb-4">{benefit.title}</h4>
                                <p className="text-black">{benefit.description}</p>
                            </div>
                            <div className="mt-auto pt-4">
                                <button onClick={() => window.location.href = '/about#features'} className="bg-yellow-400 text-black font-semibold px-6 py-2 hover:bg-yellow-500 transition">
                                    Learn More
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}